import React from 'react';

const SvgMk = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="MK_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="MK_svg__b" fill="#fff">
        <use xlinkHref="#MK_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#MK_svg__a" />
      <path fill="#E81B26" mask="url(#MK_svg__b)" d="M0 0h28v20H0z" />
      <circle fill="#FFE94F" mask="url(#MK_svg__b)" cx={14} cy={10} r={3.333} />
      <path
        d="M10.208 12.72c.201.28.433.538.69.767L1.962 23.53l-2.677-2.973 10.923-7.837zm4.707-7.297a4.69 4.69 0 0 0-1.83 0L12 0h4l-1.085 5.423z"
        fill="#FFE94F"
        mask="url(#MK_svg__b)"
      />
    </g>
  </svg>
);

export default SvgMk;
